<div class="audio-player">
  <!-- Hidden Audio Element -->
  <audio 
    #audioElement
    [src]="audioUrl"
    (loadedmetadata)="onLoadedMetadata()"
    (timeupdate)="onTimeUpdate()"
    (ended)="onEnded()"
    preload="metadata"
  ></audio>

  <!-- Player Controls -->
  <div class="player-controls">
    <!-- Skip Backward Button -->
    <button 
      class="control-btn skip-btn" 
      (click)="skipBackward()"
      [disabled]="isLoading"
      title="Indietro 10s"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M12 2v6m0 0l4-4m-4 4L8 4"/>
        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L20 7"/>
        <text x="12" y="16" text-anchor="middle" font-size="8" fill="currentColor" stroke="none">10</text>
      </svg>
    </button>

    <!-- Play/Pause Button -->
    <button 
      class="control-btn play-btn" 
      (click)="togglePlay()"
      [disabled]="isLoading"
      [attr.aria-label]="isPlaying ? 'Pausa' : 'Play'"
    >
      <!-- Play Icon -->
      <svg *ngIf="!isPlaying" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M8 5v14l11-7z"/>
      </svg>
      <!-- Pause Icon -->
      <svg *ngIf="isPlaying" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
      </svg>
    </button>

    <!-- Skip Forward Button -->
    <button 
      class="control-btn skip-btn" 
      (click)="skipForward()"
      [disabled]="isLoading"
      title="Avanti 10s"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M12 2v6m0 0l-4-4m4 4l4-4"/>
        <path d="M3.51 15a9 9 0 1 0 2.13-9.36L4 7"/>
        <text x="12" y="16" text-anchor="middle" font-size="8" fill="currentColor" stroke="none">10</text>
      </svg>
    </button>

    <!-- Time Display -->
    <div class="time-display">
      <span class="current-time">{{ formatTime(currentTime) }}</span>
      <span class="separator">/</span>
      <span class="duration">{{ formatTime(duration) }}</span>
    </div>

    <!-- Progress Bar -->
    <div class="progress-container" (click)="seek($event)">
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="progressPercent"></div>
        <div class="progress-handle" [style.left.%]="progressPercent"></div>
      </div>
    </div>

    <!-- Volume Controls -->
    <div class="volume-controls">
      <button 
        class="control-btn volume-btn" 
        (click)="toggleMute()"
        [attr.aria-label]="isMuted ? 'Attiva audio' : 'Disattiva audio'"
      >
        <!-- Volume High -->
        <svg *ngIf="!isMuted && volume > 0.5" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
        </svg>
        <!-- Volume Medium -->
        <svg *ngIf="!isMuted && volume > 0 && volume <= 0.5" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M7 9v6h4l5 5V4l-5 5H7z"/>
        </svg>
        <!-- Volume Muted -->
        <svg *ngIf="isMuted || volume === 0" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
        </svg>
      </button>

      <!-- Volume Bar -->
      <div class="volume-bar-container" (click)="changeVolume($event)">
        <div class="volume-bar">
          <div class="volume-fill" [style.width.%]="volumePercent"></div>
        </div>
      </div>
    </div>
  </div>
</div>
